// Importing components
import { FormElems, Description, ConditionalComponent, FakeLoader } from 'components';

// Importing constant
import { MAX_25MB, POPUP_ENUM } from '../../utils/constants/commonValues';
import { DEFEND_TRANSACTION_INFO_ENUM } from './constant';

// Importing Libraries
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import './updateDisputeForm.scss';

const UpdateDisputeForm = ({
    handleSubmit,
    onClose,
    onSubmit,
    transactionData,
    formData,
    isLoading
}) => {
    const [fileList, setFileList] = useState([]);

    //console.log(formData);

    const transactionDescriptionData =
        transactionData &&
        DEFEND_TRANSACTION_INFO_ENUM.map(item => {
            return { ...item, children: transactionData[item.key] };
        });

    const handleChargeBackExtensionSubmit = values => {
        onSubmit(POPUP_ENUM.UPDATE_DISPUTE, values);
    };

    return (
        <form
            className="update-refund-form"
            onSubmit={handleSubmit(handleChargeBackExtensionSubmit)}
        >
            <ConditionalComponent isVisible={isLoading}>
                <FakeLoader withMask />
            </ConditionalComponent>

            <Description items={transactionDescriptionData} />
            <div className="separator" />
            <div className="form-field ">
                <Field
                    name="refundType"
                    component={FormElems.Radio}
                    labelField="name"
                    valueField="value"
                    wrapperClass="wrap-checkbox"
                    options={[
                        {
                            name: 'Full Refund',
                            value: 'ACCEPTED',
                            checked: false,
                        }
                        // ,{
                        //     name: 'Partial Refund',
                        //     value: 'PARTIAL',
                        //     checked: false,
                        // },
                    ]}
                />
            </div>

            <ConditionalComponent
                isVisible={formData?.values?.refundType === 'PARTIAL'}
            >
                <div className="form-field-basic">
                    <p className="label">Refund Amount</p>
                    <Field
                        name="refundAmount"
                        type="number"
                        component={FormElems.Input}
                        min={1}
                        step=".01"
                        placeholder="Enter Refund Amount"
                    />
                </div>
            </ConditionalComponent>

            <div className="form-field "></div>
            <div className="form-section-actions">
                <FormElems.Button
                    buttonType="secondary"
                    id="back-btn"
                    text="Cancel"
                    type="button"
                    handleClick={onClose}
                    customClass="back-btn"
                />
                <FormElems.Button
                    id="next-btn"
                    buttonType="primary"
                    text="REFUND"
                />
            </div>
        </form>
    );
};

const mapStateToProps = ({ form }) => ({
    formData: form['update-dispute-form'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({}, dispatch),
});

export default compose(
    reduxForm({
        form: 'update-dispute-form',
        enableReinitialize: true,
        validate: () => {},
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(UpdateDisputeForm);

// PropType validation for UpdateChargeBackStatusForm component
UpdateDisputeForm.propTypes = {
    formData: PropTypes.object,
    onClose: PropTypes.func,
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func,
    subChargebackDetails: PropTypes.object,
    transactionData: PropTypes.object,
};
